export default {
  // 页面标题
  'pages.device.register.title': '设备终端',
  'pages.device.register.subtitle': '管理POS设备授权、绑定及BIR税务合规信息',

  // 统计卡片
  'pages.device.register.stat.total': '设备总数',
  'pages.device.register.stat.online': '在线设备',
  'pages.device.register.stat.offline': '离线设备',
  'pages.device.register.stat.compliant': '合规设备',
  'pages.device.register.stat.onlineRate': '在线率',

  // 按钮
  'pages.device.register.export': '导出',
  'pages.device.register.registerDevice': '注册设备',
  'pages.device.register.copy': '复制',
  'pages.device.register.edit': '编辑',
  'pages.device.register.save': '保存',
  'pages.device.register.cancel': '取消',
  'pages.device.register.confirm': '确定',
  'pages.device.register.back': '返回',

  // 提示消息
  'pages.device.register.message.exportDeveloping': '导出功能开发中...',
  'pages.device.register.exportFileName': '设备列表',
  'pages.device.register.message.exportSuccess': '导出成功',
  'pages.device.register.message.exportFailed': '导出失败',
  'pages.device.register.message.wrongPassword': '密码错误',
  'pages.device.register.message.deleteSuccess': '删除成功',
  'pages.device.register.message.deleteFailed': '删除失败',
  'pages.device.register.message.registerSuccess': '注册成功',
  'pages.device.register.message.copySuccess': '复制成功',
  'pages.device.register.message.editSuccess': '编辑成功',
  'pages.device.register.message.editFailed': '编辑失败',
  'pages.device.register.message.fetchStoreFailed': '获取门店列表失败',

  // 删除弹窗
  'pages.device.register.deleteConfirm': '删除确认',
  'pages.device.register.deleteConfirmText': '请输入密码确认删除操作：',
  'pages.device.register.deletePasswordPlaceholder': '请输入密码',

  // 搜索
  'pages.device.register.search.placeholder': '搜索设备名称、序列号(SN)',

  // 通用标签（表格列、表单、详情共用）
  'pages.device.register.deviceId': '设备ID',
  'pages.device.register.deviceName': '设备名称',
  'pages.device.register.deviceType': '设备类型',
  'pages.device.register.store': '所属门店',
  'pages.device.register.tenant': '所属租户',
  'pages.device.register.snCode': '序列号',
  'pages.device.register.activationStatus': '激活状态',
  'pages.device.register.activationCode': '激活码',
  'pages.device.register.onlineStatus': '在线状态',
  'pages.device.register.onlineStatus.online': '在线',
  'pages.device.register.onlineStatus.offline': '离线',
  'pages.device.register.expireDate': '到期日期',
  'pages.device.register.terminalNo': '终端号',

  // 表格列（独有）
  'pages.device.register.column.deviceCode': '设备硬件编码',
  'pages.device.register.column.os': '操作系统',
  'pages.device.register.column.expiryDays': '使用期限',
  'pages.device.register.column.action': '操作',
  'pages.device.register.column.bappBound': 'BAPP 绑定',
  'pages.device.register.column.version': '版本号',
  'pages.device.register.tag.bound': '已绑 {date}',
  'pages.device.register.tag.unbound': '未绑',

  // 解绑 BAPP
  'pages.device.register.message.unbindBappSuccess': 'BAPP 解绑成功',
  'pages.device.register.message.unbindBappFailed': 'BAPP 解绑失败',
  'pages.device.register.unbindBapp.title': '解绑 BAPP',
  'pages.device.register.unbindBapp.confirm': '确认解绑',
  'pages.device.register.unbindBapp.cancel': '取消',
  'pages.device.register.unbindBapp.warning':
    '设备 {name} 已绑定 BAPP（SN: {sn}），解绑后该 BAPP 将无法继续使用，确定继续吗？',

  // 分区标题
  'pages.device.register.divider.basicInfo': '基础信息',
  'pages.device.register.divider.otherInfo': '其他信息',

  // 表单 - 通用
  'pages.device.register.form.input': '请输入',
  'pages.device.register.form.select': '请选择',
  'pages.device.register.form.selectDate': '请选择',

  // 表单 - 校验与占位
  'pages.device.register.form.tenantPlaceholder': '请选择租户',
  'pages.device.register.form.tenantRequired': '请选择所属租户',
  'pages.device.register.form.storePlaceholder': '请选择门店',
  'pages.device.register.form.storePlaceholderDisabled': '请先选择租户',
  'pages.device.register.form.storeRequired': '请选择所属门店',
  'pages.device.register.form.deviceNameRequired': '请输入设备名称',
  'pages.device.register.form.deviceNamePlaceholder': '如：前台收银机 01',
  'pages.device.register.form.deviceTypeRequired': '请选择设备类型',
  'pages.device.register.form.expireDatePlaceholder': '请选择到期日期',
  'pages.device.register.form.expireDatePlaceholderEdit': '选择授权截止日期',
  'pages.device.register.form.expireDateRequired': '请选择到期日期',
  'pages.device.register.form.expireDateValidator': '到期日期不得早于当前日期',
  'pages.device.register.form.expireDateTooltip': '默认跟随租户订阅到期日',
  'pages.device.register.form.terminalNoRequired': '请输入终端号',

  // 表单 - 其他信息标签
  'pages.device.register.minNo': 'MIN号码',
  'pages.device.register.ptuNo': 'PTU号码',
  'pages.device.register.issueDate': '发行日期',
  'pages.device.register.accNo': '认证号',
  'pages.device.register.softwareName': '软件名称',

  // 详情弹窗
  'pages.device.register.detail.title': '设备详情',
  'pages.device.register.detail.basicInfo': '基本信息',
  'pages.device.register.detail.ptuInfo': 'PTU信息',

  // 签名凭证块(device-sign-v2 §11:状态/版本/签发/最后使用/最近 enroll 尝试)
  'pages.device.register.sign.sectionTitle': '签名凭证(v2)',
  'pages.device.register.sign.sectionNote':
    '凭证管理操作需具备「设备注册」权限(device:register)',
  'pages.device.register.sign.status': '凭证状态',
  'pages.device.register.sign.status.active': '有效',
  'pages.device.register.sign.status.revoked': '已吊销',
  'pages.device.register.sign.status.none': '未 enroll(无凭证)',
  'pages.device.register.sign.signVersion': '签名版本',
  'pages.device.register.sign.issuedAt': '签发时刻',
  'pages.device.register.sign.lastUsedAt': '最后使用',
  'pages.device.register.sign.lastUsedAt.never': '从未使用(停滞红旗)',
  'pages.device.register.sign.revokedAt': '吊销时刻',
  'pages.device.register.sign.attempts.title': '最近 enroll 尝试(最多 20 条)',
  'pages.device.register.sign.attempts.empty': '暂无 enroll 尝试记录',
  'pages.device.register.sign.attempts.result': '结果',
  'pages.device.register.sign.attempts.clientIp': '来源 IP',
  'pages.device.register.sign.attempts.createTime': '到达时刻',
  // enroll 终局八态(闭集,与后端审计表 result 一致)
  'pages.device.register.sign.attempts.result.ISSUED': '已签发',
  'pages.device.register.sign.attempts.result.NOT_FOUND': '设备不存在',
  'pages.device.register.sign.attempts.result.CODE_WRONG': '激活码错误',
  'pages.device.register.sign.attempts.result.NOT_ACTIVATED': '未激活',
  'pages.device.register.sign.attempts.result.DISABLED': '设备已禁用',
  'pages.device.register.sign.attempts.result.DUP_CODE': '设备编码冲突',
  'pages.device.register.sign.attempts.result.CONFLICT': '凭证冲突(须驱逐)',
  'pages.device.register.sign.attempts.result.RATE_LIMITED': '触发限流',

  // 驱逐(换码+吊销;与「重置激活码」「吊销凭证」严格区分,§4 v10)
  'pages.device.register.sign.evict': '驱逐(换码+吊销)',
  'pages.device.register.sign.evict.confirmTitle': '驱逐确认',
  'pages.device.register.sign.evict.confirmDesc':
    '将对设备执行驱逐:①激活状态回「未激活」并清空设备硬件编码;②吊销签名凭证;③生成全新激活码(仅展示这一次)。驱逐后设备须用新激活码重新激活并 enroll,是否继续?',
  'pages.device.register.sign.evict.legacyDisabled':
    '旧式公式码设备(id≤900000)不支持驱逐,请禁用设备后换绑新设备',
  'pages.device.register.sign.evict.resultTitle': '驱逐完成——新激活码',
  'pages.device.register.sign.evict.newCode': '新激活码',
  'pages.device.register.sign.evict.offlineGuide':
    '请将新激活码线下传达给装机操作者(响应仅展示这一次);设备需用新码重新激活并完成 enroll。',
  'pages.device.register.sign.evict.revokePending':
    '半失败:凭证吊销未完成(revokePending)——凭证已因设备回未激活不可用,请登记工单由运维补作清理残留凭证行。',
  'pages.device.register.sign.evict.acknowledged': '我已记录并线下传达',

  // 吊销凭证(revoke-only;二次确认+失窃场景引导改用驱逐,§11/§17)
  'pages.device.register.sign.revoke': '吊销凭证',
  'pages.device.register.sign.revoke.continue': '继续',
  'pages.device.register.sign.revoke.confirmRevoke': '确认吊销',
  'pages.device.register.sign.revoke.confirmTitle': '吊销凭证确认',
  'pages.device.register.sign.revoke.confirmDesc':
    '仅吊销设备签名凭证(revoke-only):不更换激活码、不重签发密钥;设备端恢复方式=清除本地凭证后重新 enroll。',
  'pages.device.register.sign.revoke.stolenGuide':
    '若设备已失窃/遗失,请改用「驱逐(换码+吊销)」:失窃设备本地留存的激活码会在凭证 REVOKED 后经自动签发通道自行 re-enroll 回网,仅吊销无法逐出失窃设备。',
  'pages.device.register.sign.revoke.finalTitle': '再次确认',
  'pages.device.register.sign.revoke.finalDesc':
    '确认吊销该设备的签名凭证?吊销后设备签名请求将被拒绝,直至重新 enroll。',
  'pages.device.register.sign.revoke.disabled.none':
    '设备尚未 enroll,无凭证可吊销',
  'pages.device.register.sign.revoke.disabled.revoked': '凭证已处于吊销状态',

  // 远程修复签名(SIGN_RESET 运维指令,2026-10-16 签名自愈;F2c)
  'pages.device.register.sign.reset': '远程修复签名',
  'pages.device.register.sign.reset.modalTitle': '远程修复签名(SIGN_RESET)',
  'pages.device.register.sign.reset.confirmDesc':
    '将向该设备下发签名修复运维指令:设备在下次轮询时认领并执行,完成后自动重新 enroll 签名凭证并回报结果;执行期间该设备的签名请求可能短暂失败。请核对上方设备信息后再确认。',
  'pages.device.register.sign.reset.submit': '确认下发',
  'pages.device.register.sign.reset.mode': '修复方式',
  'pages.device.register.sign.reset.mode.reEnroll':
    '重新注册凭证(清本地凭证后重 enroll,不动激活态;仅服务端已无凭证时适用)',
  'pages.device.register.sign.reset.mode.reactivate':
    '完整重新激活(用本地激活码重跑激活并吊销旧凭证后再 enroll;464/凭证冲突场景的正确指令)',
  'pages.device.register.sign.reset.activeCredentialHint':
    '服务端存在生效凭证,请保持默认的完整重新激活;重新注册凭证会被设备终态守卫拒绝',
  'pages.device.register.sign.reset.reason': '操作原因',
  'pages.device.register.sign.reset.reasonRequired': '请填写操作原因(审计必填)',
  'pages.device.register.sign.reset.reasonPlaceholder':
    '≤200 字,随指令留痕供审计追溯(如:连续 401/签名失效,远程修复)',
  'pages.device.register.sign.reset.sent':
    '指令已下发,将随设备下次轮询生效(默认间隔下最坏约 5 分钟)',
  'pages.device.register.sign.reset.disabled.none':
    '设备尚未 enroll(无凭证):下次 enroll 会自动签发新凭证,无需远程修复',
  'pages.device.register.sign.reset.disabled.notActivated':
    '设备未激活,无法远程修复签名(请先完成设备激活)',
  'pages.device.register.sign.reset.disabled.noPerm':
    '无远程运维权限(ops:deviceOps),不可下发运维指令',

  // 编辑弹窗
  'pages.device.register.editTitle': '编辑设备',

  // 新增弹窗
  'pages.device.register.addTitle': '注册设备',
};
